module.exports = __webpack_public_path__ + "static/media/AndrewPedersen_resumeSmall.aa36dff0.png";